export const isSiteInShellCookieName = "isSiteInShell";
export const contentModeCookieName = "cms_CurrentContentMode";
export const contentModeSignatureCookieName = "cms_CurrentContentModeSignature";
export const isMobileAppCookieName = "cms_IsMobileApp";
export const optiIdTokenCookieName = "opti_id_token";

type ContentMode = "Viewing" | "Editing" | "Previewing";
export default ContentMode;
